import React from "react";
import { Box, Grid, TextField } from "@mui/material";
import { ReceivingResponse } from "../../../app/models/responseModels/receivingResponse";
import SubmitModal from "../../../components/common/modalPopup/SubmitModal";

interface ViewReceivingModalProps {
  closeViewReceivingModal: CallableFunction;
  onCompleted: CallableFunction;
  receivingRowData: ReceivingResponse;
}

const ViewReceivingModal = ({
  closeViewReceivingModal,
  onCompleted,
  receivingRowData,
}: ViewReceivingModalProps) => {
  const handleSubmit = async () => {
    onCompleted();
    return true;
  };

  return (
    <>
      <SubmitModal
        title="View Receiving Package"
        asyncOperation={handleSubmit}
        closeSubmitModal={closeViewReceivingModal}
        allowSubmit={false}
        size="lg"
        isLoading={false}
        closeModalAfterSubmit={true}
        showSubmitButton={false}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Grid container rowSpacing={2} columnSpacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                margin="normal"
                id="parcelCenter"
                label="Parcel Center"
                name="parcelCenter"
                size="small"
                fullWidth
                required
                value={receivingRowData.parcelCenterLocationName}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                margin="normal"
                id="client"
                label="Client"
                name="client"
                size="small"
                fullWidth
                disabled
                value={receivingRowData.clientName}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                margin="normal"
                id="fdp"
                label="FDP"
                name="fdp"
                size="small"
                fullWidth
                disabled
                value={receivingRowData.fdpCompanyName}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                margin="normal"
                id="fdpId"
                label="FDP ID"
                name="fdpId"
                size="small"
                fullWidth
                disabled
                value={receivingRowData.packageFdpId}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                margin="normal"
                id="packageTrackingNumber"
                label="Package Tracking Number"
                name="packageTrackingNumber"
                size="small"
                fullWidth
                required
                value={receivingRowData.packageTrackingNumber}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                margin="normal"
                id="arrivalDate"
                label="Arrival Date"
                name="arrivalDate"
                size="small"
                fullWidth
                required
                value={new Date(receivingRowData.arrivalDate).toLocaleString(
                  "en-US",
                  {
                    hourCycle: "h24",
                  }
                )}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                margin="normal"
                id="scheduledDeliveryDate"
                label="Scheduled Delivery Date"
                name="scheduledDeliveryDate"
                size="small"
                fullWidth
                disabled
                value={receivingRowData.packageDeliveryDate}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                margin="normal"
                id="workArea"
                label="Work Area"
                name="workArea"
                size="small"
                fullWidth
                disabled
                value={receivingRowData.packageWorkArea}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                margin="normal"
                id="sid"
                label="SID"
                name="sid"
                size="small"
                fullWidth
                disabled
                value={receivingRowData.packageSid}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                margin="normal"
                id="status"
                label="Status"
                name="status"
                size="small"
                fullWidth
                disabled
                value={receivingRowData.packageStatus}
              />
            </Grid>
          </Grid>
        </Box>
      </SubmitModal>
    </>
  );
};

export default ViewReceivingModal;
